export default __webpack_public_path__ + "static/media/img111.e1928652.png";